import { Avatar } from '../Avatar';

import { Actions } from './Actions';
import { AssessmentType } from './AssessmentType';
import { Content } from './Content';
import { PersonalProfile } from './PersonalProfile';
import { ProfileBadge } from './ProfileBadge';
import { ProfileContainer } from './ProfileContainer';
import { ProfileGroup } from './ProfileGroup';
import { ProfileRoot } from './ProfileRoot';

export const safeTitleAndZone = (title?: string, zone?: string) =>
  [title, zone].filter(Boolean).join(' - ');

export const EmployeeProfile = {
  Root: ProfileRoot,
  Container: ProfileContainer,
  Actions,
  Badge: ProfileBadge,
  AssessmentType,
  Content,
  Group: ProfileGroup,
  Avatar,
  PersonalProfile,
};
